"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function createEntityKey(data) {
  if (data.type && data.id) {
    return data.type + "-" + data.id;
  }
  return '';
}
var JsonDeserializer = /** @class */function () {
  function JsonDeserializer(propertiesMapper, deserializeCache) {
    this.cachedModels = {};
    this.setPropertiesMapper(propertiesMapper);
    this.setDeserializeCache(deserializeCache);
  }
  JsonDeserializer.prototype.setDeserializeCache = function (dc) {
    this.dc = dc;
  };
  JsonDeserializer.prototype.setPropertiesMapper = function (pm) {
    this.pm = pm;
  };
  JsonDeserializer.prototype.setJsonParsedObject = function (body) {
    this.body = body;
  };
  JsonDeserializer.prototype.build = function () {
    var data = this.body.data;
    var stuff;
    if (Array.isArray(data)) {
      stuff = [];
      var collectionLength = data.length;
      for (var i = 0; i < collectionLength; i++) {
        if (data[i]) {
          var model = this.buildModelByData(data[i]);
          if (model) {
            stuff.push(model);
          }
        }
      }
    } else if (data) {
      stuff = this.buildModelByData(data);
    }
    return stuff;
  };
  JsonDeserializer.prototype.buildModelByData = function (data) {
    var cachedModel = this.dc.getCachedModel(data);
    if (cachedModel) {
      return cachedModel;
    }
    var model = this.pm.createModel(data.type);
    this.dc.handleModel(model, data); // should be called before this.pm.setRelationships(model, relationships);
    if (model) {
      this.pm.setId(model, data.id);
      if (data.attributes) {
        this.pm.setAttributes(model, data.attributes);
      }
      if (data.meta && this.pm.setMeta) {
        this.pm.setMeta(model, data.meta);
      }
      if (data.links && this.pm.setLinks) {
        this.pm.setLinks(model, data.links);
      }
      var relationships = this.buildRelationsByData(data, model);
      if (relationships) {
        this.pm.setRelationships(model, relationships);
      }
    }
    return model;
  };
  JsonDeserializer.prototype.buildRelationsByData = function (data, model) {
    var readyRelations = {};
    if (data.relationships) {
      for (var k in data.relationships) {
        var relation = data.relationships[k];
        if (Array.isArray(relation.data)) {
          readyRelations[k] = [];
          var relationItemsLength = relation.data.length;
          var relationItem = void 0;
          for (var i = 0; i < relationItemsLength; i++) {
            relationItem = relation.data[i];
            if (!relationItem) {
              return;
            }
            var dataItem = this.buildDataFromIncludedOrData(relationItem.id, relationItem.type);
            readyRelations[k].push(this.buildModelByData(dataItem));
          }
        } else if (relation.data) {
          var dataItem = this.buildDataFromIncludedOrData(relation.data.id, relation.data.type);
          readyRelations[k] = this.buildModelByData(dataItem);
        } else if (relation.data === null) {
          readyRelations[k] = null;
        }
        if (relation.links) {
          var setRelationshipLinks = this.pm.setRelationshipLinks;
          if (setRelationshipLinks) {
            setRelationshipLinks(model, k, relation.links);
          }
        }
        if (relation.meta) {
          var setRelationshipMeta = this.pm.setRelationshipMeta;
          if (setRelationshipMeta) {
            setRelationshipMeta(model, k, relation.meta);
          }
        }
      }
    }
    if (Object.keys(readyRelations).length) {
      return readyRelations;
    }
    return null;
  };
  JsonDeserializer.prototype.buildDataFromIncludedOrData = function (id, type) {
    var included = this.buildIncludedInObject();
    var dataItem = included[type + id];
    if (dataItem) {
      return dataItem;
    } else {
      return {
        id: id,
        type: type
      };
    }
  };
  JsonDeserializer.prototype.buildIncludedInObject = function () {
    if (!this.includedInObject) {
      this.includedInObject = {};
      if (this.body.included) {
        var includedLength = this.body.included.length;
        for (var i = 0; i < includedLength; i++) {
          var item = this.body.included[i];
          this.includedInObject[item.type + item.id] = item;
        }
      }
    }
    return this.includedInObject;
  };
  return JsonDeserializer;
}();
exports["default"] = JsonDeserializer;